export const PENDING_ACCOUNT_TOOLTIP_MESSAGE =
  "Your workplace's account is pending and you cannot send Shift Invites to professionals. Please submit payment or contact us at billing@clipboardhealth.com for assistance.";

export const NO_MATCHING_QUALIFICATION_TOOLTIP_MESSAGE =
  "This professional does not have an active license for any of your facility's roles";
